const acl = {
  tabUsers: 'المستخدمين',
  tabPermissions: 'صلاحيات الأدوار',
  selectRoleToEdit: 'اختر دوراً لتعديل الصلاحيات',
  featuresEnabled: 'ميزات مفعلة',
  savePermissions: 'حفظ الصلاحيات',
  rolePermissionHint: 'تكوين صلاحيات الوصول لـ {{role}}. قم بتمكين أو تعطيل الميزات ومستويات الصلاحيات الخاصة بها.',
  unsavedChanges: 'لديك تغييرات غير محفوظة.',
  grantAll: 'منح جميع الصلاحيات',
  removeAll: 'إزالة جميع الصلاحيات',
  permissionsSaved: 'تم حفظ الصلاحيات بنجاح.',
  permView: 'عرض',
  permCreate: 'إنشاء',
  permEdit: 'تعديل',
  permDelete: 'حذف',
  permManage: 'إدارة',
  noAccess: 'لا يوجد وصول',
};

export default acl;